<template>
  <div class="rt-list-wrapper">
    <p class="rt-list-title">{{ title }}</p>
    <div class="rt-list-slot">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RealtimeList',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang='less' scoped>
.rt-list-wrapper {
  padding: 8px 12px;
  .rt-list-title {
    position: relative;
    color: #ebebf0;
    font-size: 14px;
    font-weight: 600;
    padding: 0 12px;
    margin-bottom: 20px;
    &::before {
      content: '';
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      height: 14px;
      width: 6px;
      border-radius: 1px;
      left: 0;
      background-color: #3377fe;
    }
  }
  .rt-list-slot {
    display: flex;
  }
}
</style>
